import BarGraphs from "../../components/ClassOne/Mathematics/BarGraphs";
import LineCharts from "../../components/ClassOne/Mathematics/LineCharts";
import Pictographs from "../../components/ClassOne/Mathematics/Pictographs";
import Tables from "../../components/ClassOne/Mathematics/Tables";


// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/mathematics/data-handling/pictographs", title: "Pictographs", component: Pictographs },
    { url: "/class-one/mathematics/data-handling/bar-graphs", title: "Bar Graphs", component: BarGraphs },
    { url: "/class-one/mathematics/data-handling/tables", title: "Tables", component: Tables },
    { url: "/class-one/mathematics/data-handling/line-graphs", title: "Line Graphs", component: LineCharts }
];

export default topics;